import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  InputLabel,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
  getStatusStyleV3,
} from "../../Utility/Utilitys";
import { IMPURTrip_Summary } from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import {
  DataGridPro,
  gridRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import HeaderComponent from "../ImportPurchasePlanning/processComponent/HeaderComponent";
import TripPlanningDetail from "./TripPlanningDetail";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { FormControl } from "react-bootstrap";

const TripPlanningSummary = () => {
  const uMediaQuery = useMediaQuery("(max-width:390px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const status = ["All", "Open", "Close"];
  const dispatch = useDispatch();
  const [summaryData, setSummaryData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [isPopModalDataChanged, setIsPopModalDataChanged] = useState(false);

  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithoutRights
  );
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    location: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
    status: "All",
  });

  const handleLoadBtn = () => {
    fonLoad();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };
  // Convert CSV string to array
  const csvToArr = (csv) =>
    typeof csv === "string" && csv.trim()
      ? csv
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
    setOpen(true);
  };

  const fNew = () => {
    setSelectedRow({
      TripId: 0,
      Name: "",
      Buyer: "",
      Expt_From: moment().startOf("month").toDate(),
      Expt_To: moment().toDate(),
      Status: "",
    });
    setOpen(true);

    setTimeout(() => {
      document.getElementsByName("Name")[0]?.focus();
    }, 200);
  };

  const apiRef = useGridApiRef();
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      // ALL loaded rows (ignores selection)
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
      // allColumns: true,
    });
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };

  const fonLoad = async (
    
    status = filterObj?.status,
    fromdate = filterObj?.dateFrom,
    todate = filterObj?.dateTo
  ) => {
    const vRdxUserInfoObj = vRdxUserInfo();
try{
    var obj = {
      FromDate: moment(fromdate).format("MM/DD/YYYY"),
      ToDate: moment(todate).format("MM/DD/YYYY"),
      Status: status,
      UserCd: vRdxUserInfoObj?.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const resp = await IMPURTrip_Summary(FinalObj);

    if (resp?.status === 200) {
      console.log(resp);

      if (resp?.data?.ResultSet?.length > 0) {
        setSummaryData(resp?.data?.ResultSet);
      }
    } else {
      setSummaryData([]);
    }
    } catch (error) {}
  };

  useEffect(() => {
    fonLoad();
  }, []);

  return (
    <div className="div-container">
      <Box pt={vMediaQuery ? 0 : 2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                Trip Planning
              </Typography>
            </Grid>
            <Grid item xs={2} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fNew}
              >
                New
              </Button>
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Export CSV" sx={{ mt: 0.5 }}>
                <IconButton color="primary" onClick={handleExport} size="small">
                  <DownloadOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Trip Planning
            </Typography>

            <HeaderComponent
              fNew={fNew}
              status={status}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              vRdxDBLocation={vRdxuserLoc}
              handleExport={handleExport}
              handleLoadBtn={handleLoadBtn}
              setIsPopModalDataChanged={setIsPopModalDataChanged}
              title="Trip"
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 1 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: { xs: "75vh", sm: "60vh", md: "68vh", lg: "68vh" },
            width: "100%",
          }}
        >
          <DataGridPro
            rowHeight={30}
            headerHeight={40}
            apiRef={apiRef}
            rows={summaryData}
            getRowId={(v) => v.TripId}
            columns={[
              {
                field: "TripId",
                headerName: "TripId",
                width: xMediaQuery ? 60 : 80,
                align: "left",
                headerAlign: "left",
              },
              
              {
                field: "Name",
                headerName: " Trip Name",
                width: xMediaQuery ? 80 : 200,
              },
              {
                field: "Expt_From",
                headerName: "Expected From",
                width: xMediaQuery ? 80 : 120,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
                align: "center",
                headerAlign: "center",
              },
              {
                field: "Expt_To",
                headerName: "Expected To",
                width: xMediaQuery ? 80 : 120,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
                align: "center",
                headerAlign: "center",
              },

              {
                field: "BuyerName",
                headerName: "Buyer",
                width: 140,
                align: "left",
                headerAlign: "left",
              },

              {
                field: "Status",
                headerName: "Status",
                width: 100,
                align: "center",
                headerAlign: "center",
                renderCell: (params) => {
                  const style = getStatusStyleV3(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
              {
                field: "IsDeactivity",
                headerName: "IsDeactivity",
                width: 100,
                align: "center",
                headerAlign: "center",
                renderCell: (params) => {
                  const style = getStatusStyleV3(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },

              {
                field: "EnDt",
                headerName: "Entry Date",
                width: 100,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },

              {
                field: "EnByName",
                headerName: "Entry Name",
                width: xMediaQuery ? 80 : 120,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "ApDt",
                headerName: "Approved Date",
                width: 120,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "ApBy",
                headerName: "Approved By",
                width: 120,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "DeactivityBy",
                headerName: "DeactiviatedBy",
                width: 120,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "DeactivityByName",
                headerName: " DeactiviatedByName",
                width: 140,
                align: "center",
                headerAlign: "center",
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowClick={handleRowClick}
          />
        </Box>
        {vMediaQuery && (
          <CmpModal
            open={openFilterModal}
            onClose={() => setOpenFilterModal(false)}
            title="Filter"
            width={"95%"}
            height={"auto"}
            component={
              <HeaderComponent
                closeModal={() => setOpenFilterModal(false)}
                status={status}
                handleLoadBtn={handleLoadBtn}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                vRdxDBLocation={vRdxuserLoc}
                title="Trip"
                handleExport={handleExport}
              />
            }
          />
        )}

        <TripPlanningDetail
          open={open}
          onClose={() => setOpen(false)}
          setOpen={setOpen}
          filterObj={filterObj}
          loadSummary={fonLoad}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          summaryData={summaryData}
          setSummaryData={setSummaryData}
        />
      </Box>
    </div>
  );
};

export default TripPlanningSummary;
